//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action$Type } from '../genericFlowTypes'

const initialState:ReducerState$Type = {
    error: '',
    invoiceSubmitted: false,
    resultset: null,
    anyChanges: false,
    formData: {},
    reviewQuestions: [],
    formError: {},
    cacheValues: null,
    formTypes: [
        { code: 'ec', desc: 'EC'},
        { code: 'rr', desc: 'RR'},
        { code: 'rrb', desc: 'RRB'},
        { code: 'rru', desc: 'RRU'},
        { code: 'exc', desc: 'Exception Form'}
    ],
    formServiceYears: [
        { code: 2017, desc: '2017'},
        { code: 2018, desc: '2018'},
        { code: 2019, desc: '2019'},
        { code: 2020, desc: '2020'}
    ],
    correspondenceTypes: [
        { code: 'Administrative Appeal (English)', desc: 'Administrative Appeal (English)'},
        { code: 'Certification of No Rent Collected', desc: 'Certification of No Rent Collected'},
        { code: 'Conditional Exemption Application', desc: 'Conditional Exemption Application'},
        { code: 'Registration Exemption Application', desc: 'Registration Exemption Application'},
        { code: 'Refund Form', desc: 'Refund Form'},
        { code: 'Unit Count Discrepancy Form (English)', desc: 'Unit Count Discrepancy Form (English)'},
        { code: 'Application to Appeal', desc: 'Application to Appeal'},
        { code: 'Annual Rent Registry (Web-Form Submission)', desc: 'Annual Rent Registry (Web-Form Submission)'},
        { code: 'Notice of Temporary Units', desc: 'Notice of Temporary Units'},
        { code: 'EC20b', desc: 'EC20b'}
    ],
    usStates: [
        { code: 'AK', desc: 'AK - ALASKA'},
        { code: 'AL', desc: 'AL - ALABAMA'},
        { code: 'AR', desc: 'AR - ARKANSAS'},
        { code: 'AZ', desc: 'AZ - ARIZONA'},
        { code: 'CA', desc: 'CA - CALIFORNIA'},
        { code: 'CO', desc: 'CO - COLORADO'},
        { code: 'CT', desc: 'CT - CONNECTICUT'},
        { code: 'DC', desc: 'DC - DISTRICT OF COLUMBIA'},
        { code: 'DE', desc: 'DE - DELAWARE'},
        { code: 'FL', desc: 'FL - FLORIDA'},
        { code: 'GA', desc: 'GA - GEORGIA'},
        { code: 'HI', desc: 'HI - HAWAII'},
        { code: 'IA', desc: 'IA - IOWA'},
        { code: 'ID', desc: 'ID - IDAHO'},
        { code: 'IL', desc: 'IL - ILLINOIS'},
        { code: 'IN', desc: 'IN - INDIANA'},
        { code: 'KS', desc: 'KS - KANSAS'},
        { code: 'KY', desc: 'KY - KENTUCKY'},
        { code: 'LA', desc: 'LA - LOUISIANA'},
        { code: 'MA', desc: 'MA - MASSACHUSETTS'},
        { code: 'MD', desc: 'MD - MARYLAND'},
        { code: 'ME', desc: 'ME - MAINE'},
        { code: 'MI', desc: 'MI - MICHIGAN'},
        { code: 'MN', desc: 'MN - MINNESOTA'},
        { code: 'MO', desc: 'MO - MISSOURI'},
        { code: 'MS', desc: 'MS - MISSISSIPPI'},
        { code: 'MT', desc: 'MT - MONTANA'},
        { code: 'NC', desc: 'NC - NORTH CAROLINA'},
        { code: 'ND', desc: 'ND - NORTH DAKOTA'},
        { code: 'NE', desc: 'NE - NEBRASKA'},
        { code: 'NH', desc: 'NH - NEW HAMPSHIRE'},
        { code: 'NJ', desc: 'NJ - NEW JERSEY'},
        { code: 'NM', desc: 'NM - NEW MEXICO'},
        { code: 'NV', desc: 'NV - NEVADA'},
        { code: 'NY', desc: 'NY - NEW YORK'},
        { code: 'OH', desc: 'OH - OHIO'},
        { code: 'OK', desc: 'OK - OKLAHOMA'},
        { code: 'OR', desc: 'OR - OREGON'},
        { code: 'PA', desc: 'PA - PENNSYLVANIA'},
        { code: 'RI', desc: 'RI - RHODE ISLAND'},
        { code: 'SC', desc: 'SC - SOUTH CAROLINA'},
        { code: 'SD', desc: 'SD - SOUTH DAKOTA'},
        { code: 'TN', desc: 'TN - TENNESSEE'},
        { code: 'TX', desc: 'TX - TEXAS'},
        { code: 'UT', desc: 'UT - UTAH'},
        { code: 'VA', desc: 'VA - VIRGINIA'},
        { code: 'VT', desc: 'VT - VERMONT'},
        { code: 'WA', desc: 'WA - WASHINGTON'},
        { code: 'WI', desc: 'WI - WISCONSIN'},
        { code: 'WV', desc: 'WV - WEST VIRGINIA'},
        { code: 'WY', desc: 'WY - WYOMING'}
    ]
}

//In use : actionTypes.KRATOS_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: ''
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const updateFormError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const headerActionsError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: action.error
    }
}

const refreshCacheValue=(state:ReducerState$Type,action:Action$Type)=> {
    let cacheValues = state.cacheValues
    if (!cacheValues) {
        cacheValues = new Map()
    }

    cacheValues.set(action.anyKey,action.anyValue)

    return {
        ...state,
        cacheValues: cacheValues
    }
}

export default reduce(initialState,{
    [actionTypes.KRATOS_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.KRATOS_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.KRATOS_INV_SUBMIT_ERROR]: headerActionsError,
    [actionTypes.KRATOS_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.KRATOS_EDIT_VERIFY_FORM_DATA_ERROR]: headerActionsError,
    [actionTypes.KRATOS_UPDATE_FORM_ERROR]: updateFormError,
    [actionTypes.REFRESH_KRATOS_CACHE_VALUE]: refreshCacheValue
});


// WEBPACK FOOTER //
// ./src/redux/kratos/reducer.js